import React, { forwardRef, useState } from 'react';
import dayjs from 'dayjs';
import _ from 'underscore';
import { Popover, Button } from 'antd';
import BaseCalender2 from '../calendar/base_calendar2';

// import { Button } from 'antd';
const BaseDateTimePicker = (props) => {
  const { label, readonly, width, ...rest } = props;

  const [open, onOpenChange] = useState(false);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '5.8rem',
    },
    label: {
      display: 'flex',
      height: '2rem',
      alignItems: 'center',
      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
      // color: 'black',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      height: '3.8rem',
      width: '100%',
      justifyContent: 'space-between',
      padding: '0rem 0rem 0rem 1.4rem',
      background: 'transparent',
      border: '1px solid #DBDADE',
      borderRadius: 6,

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.4rem',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.label }}>{label}</div>
      <div style={{ ...styles.text }}>
        <div>
          {
            //_.isDate(props.value)
            props.value
              ? dayjs(props.value).format('YYYY-MM-DD(HH:mm)')
              : '일시를 선택해 주세요'
          }
        </div>
        {readonly ? (
          <img
            width={38}
            height={38}
            src={require('../../assets/images/ico_calendar.png')}
          />
        ) : (
          <Popover
            placement="leftTop"
            title={undefined}
            content={<BaseCalender2 {...rest} onOpenChange={onOpenChange} />}
            trigger="click"
            overlayStyle={{ width: 240 }}
            overlayInnerStyle={{ padding: 0 }}
            showArrow={false}
            open={open}
            onOpenChange={() => {
              onOpenChange(true);
            }}
          >
            <Button
              // type="primary"
              style={{ margin: 0, padding: 0, width: 38, height: 38 }}
              icon={
                <img
                  width={38}
                  height={38}
                  src={require('../../assets/images/ico_calendar.png')}
                />
              }
              // size={'small'}
            />
          </Popover>
        )}
      </div>
    </div>
  );
};

export default forwardRef(BaseDateTimePicker);
